import moment from 'moment';
import { DEFAULT_BRANDING } from '../../../redux/slices/branding/brandingSlice';
import { KA_VISUALIZATION_DEFAULTS } from '../kaVisualizationDefaults';

const sDate = moment().utc().add(-29, 'days').startOf('day').toISOString();
const eDate = moment().utc().endOf('day').toISOString();

// Function to get agentState with custom primary color
export const getAgentState = (primaryColor = DEFAULT_BRANDING.primaryColor) => ({
  data: {
    title: '',
    companyLogo: '',
    playbookId: '',
    domainConfig: {
      type: 'fullDomain',
      exceptions: [],
      domainId: '',
      paths: [],
      pageMetaDataDomainConfig: {
        fromPublishedDate: '',
        tags: [],
        categories: [],
        authors: [],
        wordsCount: 0,
      },
    },
    automation: {
      hotspotFinder: true,
    },
    visualization: {
      zIndex: 1,
      primaryColor: primaryColor,
      darkTheme: false,
      language: 'en',
      fontScale: 1,
      fontScaleMobile: 1,
      logoScale: 1,
      logoScaleMobile: 1,
      showLogo: true,
      backgroundPosition: 'center',
      cardSize: {
        autoWidth: true,
        height: 400,
        width: 600,
        maxWidth: null,
      },
      cardSizeMobile: {
        autoWidth: true,
        height: 400,
        width: 600,
        maxWidth: null,
      },
      fontFamily: {
        fontType: 'googleFont',
        fontName: KA_VISUALIZATION_DEFAULTS.fontFamily,
        fontURL: '',
      },
      cardStyle: {
        borderRadius: [16, 16, 16, 16],
        margin: [0, 0, 0, 0],
        boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.4)',
      },
      animatedBorder: {
        ...KA_VISUALIZATION_DEFAULTS.animatedBorder,
      },
    },
    placements: [
      {
        deviceType: 'desktop',
        spotLightAnimation: false,
        ignoreCLS: true,
        placementData: null, // this is used to store the placement data
      },
    ],

    campaignData: {
      showActionAfterResponses: 0,
      publishedDate: {
        startDate: sDate,
        endDate: eDate,
      },
      hasPaywall: false,
      engagementNumberType: 'engagementView',
      engagementGenerationByAI: false,
      engagementGenerationByAICount: 1,
      engagementsABTest: true,
      engagements: [],
      actions: [],
      staticReferences: [],
      engagementViewLimit: null,
      numActionsToShow: 3,
      actionsABTest: true,
      actionExpirationInDays: 7,
      campaignType: '',
      endScreen: {},
      gatedEngagement: false,
      engagementGeneratorConfigurations: {
        autoApproval: true,
        tone: 'formal',
        avoidList: [],
        engagementType: '4_option_poll',
        engagementTemplate: 'default',
      },
      ctaPreviewConfig: {
        isActive: false,
        showDescription: false,
      },
      termsAndConditions: {
        isActive: false,
        title: '',
        url: '',
      },
      articleRelatedQuestions: {
        isActive: false,
        relatedQuestionType: '',
        questions: [],
      },
      ragConfig: {
        engineType: 'simple',
        format: 'para_answer',
        retrievalTechnique: '',
        articleRelatedQuestions: {
          isActive: false,
          relatedQuestionType: '',
          questions: [],
          // FAQ keywords (AI generated only): the use case, its keywords, and whether the
          // organiser changed them from the use case's defaults.
          audience: '',
          keywords: [],
          keywordsEdited: false,
        },
      },
      engagementTitle: '',
      engagementDescription: '',
      footerConfig: {
        isActive: false,
        footers: [
          {
            screenType: 'engagement',
            footerText: '',
          },
          {
            screenType: 'actions',
            footerText: '',
          },
          {
            screenType: 'endScreen',
            footerText: '',
          },
        ],
      },
      feedbackConfig: {
        isActive: false,
        title: '',
        type: '',
      },
      actionBucketId: '',
      actionBucketIds: [],
      xrayQuestions: [
        {
          type: 'summary',
          isIncluded: true,
          questionText: "What's the summary?",
          userGuideline: 'Capture all the main context of the article in EXACTLY 3 bullet points.',
        },
        {
          type: 'keyPeople',
          isIncluded: false,
          questionText: 'Who are the key people mentioned?',
          userGuideline: 'Extract the names of the people involved, maximum of 4 people.',
        },
        {
          type: 'keyFact',
          isIncluded: false,
          questionText: 'What are the key facts?',
          userGuideline:
            'MAKE SURE that each fact/point IS a single complete sentence with at most 200 characters. Generate Exactly 4 relevant KEY NUMERICAL statistics from the entire Query article.If there are no NUMERICAL STATS, return 4 major FACTS/CONCLUSIONS from the article.',
        },
        {
          type: 'quotes',
          isIncluded: false,
          questionText: 'What quotes are mentioned ?',
          userGuideline:
            "Identify the Top 3 quotes that highlight the context of the paragraph. Use quotes only if it is clearly stated and is NOT ANONYMOUS. Extract such quotes and use it only IF the speaker is KNOWN and identified and then put it in a JSON object and return it. Don't change the KEY NAME. Remember: If the speaker name cannot be identified don't use the quote. Also always extract the title/position of the speaker of the quote, if available.",
        },
        {
          type: 'relatedTopics',
          isIncluded: false,
          questionText: 'What are the related topics?',
          userGuideline: '',
        },
        {
          type: 'relatedAuthors',
          isIncluded: false,
          questionText: 'Who are the related authors?',
          userGuideline: '',
        },
        {
          type: 'linkActions',
          isIncluded: false,
          questionText: 'What are the related articles?',
          userGuideline: '',
        },
        {
          type: 'terminology',
          isIncluded: false,
          questionText: 'What is the terminology?',
          userGuideline:
            'Extract the glossary of terms that are specialised to this article content and return in json format with term and its definition, maximum of 10 sets , term should be extracted as is(unchanged, from the original article) and Include terms that are article centric.',
        },
      ],
      aiSimilarityActionBucketId: '',
      disclaimer: '',
      linkActions: [],
      linkedIntents: [
        {
          intent: 'no_intent_detected',
          intentDescription: 'This intent will be used as a fallback if no intent is detected',
          actionId: '',
        },
      ],
      engineId: '',
      textAreaPlaceHolder: '',
      buttonText: '',
      closeButtonPlacement: 'SCREEN_TOP_RIGHT',
      referenceSectionHeader: '',
      autoExpansion: false,
      poweredByBridged: true,
      personalizationTool: {
        isActive: false,
        ctasConfig: {
          userInputCTAId: null,
          registrationCTAId: null,
          hasExportResult: false,
        },
        lockResult: false,
        type: 'registrant',
        interfaceVariant: 'V2',
        requiredFields: [],
        isPTStreaming: true,
        exportEmailConfig: {
          provider: 'bridged',
          mailbox: '',
          clientId: '',
          clientSecret: '',
          authority: '',
        },
        actionBucketIds: [],
      },
      ctaWebhookIntegrationConfig: [],
    },
    segmentId: 'allVisitors',
    aiEngagementsNeedUpdate: false,
    activationScheduleConfig: {
      isActive: false,
      startDate: '',
      endDate: '',
    },
  },
  etc: {
    isAgentEditLoading: false,
    agentStep: 0,
    goalSubStep: 0,
    selectedPlaybook: null,
    engagementSelection: 'selectManually',
    creationType: '',
    currentSelectedPlacement: 'desktop',
    endScreen: {
      isNewEndScreenOpen: false,
      isAddEndScreenOpen: false,
    },
    engagement: {
      isNewEngagementOpen: false,
      isAddEngagementOpen: false,
    },
    cta: {
      isNewCTAOpen: false,
      isAddCTAOpen: false,
      isNewLinkCTAOpen: false,
      isAddLinkCTAOpen: false,
      isNewStaticCTAOpen: false,
      isAddStaticCTAOpen: false,
      isShowStaticCTAs: false,
      isNewIntentCTAOpen: false,
      isAddIntentCTAOpen: false,
    },
    collections: {
      isNewCollectionOpen: false,
      isAddCollectionOpen: false,
      isAddAISimilarityCollectionOpen: false,
      isAddPersonalizationCollectionOpen: false,
    },
    engine: {
      isNewEngineOpen: false,
      newMatchingEngineId: null,
      isAddEngineOpen: false,
      engineList: [],
    },
    isAIAgent: false,
    numberOfAIEngagements: 1,
    agentType: '',
    showMandatoryCTA: false,
    intentBasedCtaIsActive: false,
    personalizationCta: {
      isAddUserInputCTAOpen: false,
      isAddRegistrationCTAOpen: false,
      isKAPersonalizationNewCtaOpen: false,
      kaPersonalizationNewCtaTargetSlot: null,
    },
    brandSync: {
      domainId: '',
      domainName: '',
      brandInfo: {},
      hasInitialFetch: false,
      appliedEventId: null,
    },
    isDefaultMargin: true,
    isDefaultCornerRadius: true,
    isBoxShadowEnabled: true,
    selectedBrandSyncProperties: {},
    currentSelectedIntent: null,

    // * qualification related

    isScriptAdded: false,
    stageType: 'scoreBased',

    // * poll cta mapping related
    pollCtaMapping: {
      pollCTAsUsageType: 'abTest',
      ABtestActions: [],
      mappedOptions: [],
      ctaStates: {
        isNewABTestCtaOpen: false,
        isAddABTestCtaOpen: false,
        isNewMappingCtaOpen: false,
        isAddMappingCtaOpen: false,
      },
    },
  },
  aiAgent: {
    title: '',
    description: '',
    aiAgentData: {
      aiAgentType: 'ProSEOOptimizer',
      engineType: 'default',
      feedConfig: {
        isActive: false, // toggle with locked
      },
      // CMSPublishConfig: {
      //   isActive: false, // toggle with lock
      // },

      tagSuggestorConfig: {
        isActive: false, // toggle with lock
      },
      backLinkGeneratorConfig: {
        isActive: false, // toggle with lock
        model: '',
        actionBucketId: '',
        provider: '',
        documentsLimit: 1,
        responseFormat: '',
        useRerank: false,
      },
      visualization: {
        darkTheme: false,
        primaryColor: '#f28b82',
        language: 'en',
        fontScale: 1,
        logoScale: 1,
        fontFamily: {
          fontType: 'googleFont',
          fontName: KA_VISUALIZATION_DEFAULTS.fontFamily,
        },
        zIndex: 1,
        cardStyle: {
          boxShadow: '   ',
          margin: '',
          borderRadius: '0px 0px 0px 0px',
        },
        logo: '',
        buttonStyle: {
          backgroundColor: '#00a4b8',
          borderRadius: '9px 9px 9px 9px',
          boxShadow: '',
          padding: '',
          isCustomPosition: false,
          top: '30px',
          bottom: '30px',
          left: '30px',
          right: '30px',
          bottomBarPosition: {
            bottom: '30px',
          },
          templateType: 'ka-search',
          isFloatingSidePanel: false,
          textStyle: {
            text: KA_VISUALIZATION_DEFAULTS.fabButtonText,
            textColor: '#ffffff',
            fontSize: '',
            fontWeight: '',
            fontFamily: KA_VISUALIZATION_DEFAULTS.fontFamily,
          },
          iconStyle: {
            icon: 'https://loader.bridged.media/ai-white.png',
            iconHeight: '',
          },
          isGradientAnimation: true,
          shinyBorder: {
            ...KA_VISUALIZATION_DEFAULTS.shinyBorder,
          },
          tooltipStyle: {
            text: KA_VISUALIZATION_DEFAULTS.fabTooltip,
            textColor: '#ffffff',
            fontSize: '',
            fontWeight: '',
            fontFamily: KA_VISUALIZATION_DEFAULTS.fontFamily,
            backgroundColor: '#753fd0',
            position: 'top',
            isDefaultOpen: true,
          },
        },
      },
    },
  },
  smartReply: {
    title: '',
    language: 'en',
    smartReplyData: {
      type: 'website',
      engineId: '',
      actionBucketIds: [],

      // email KA related
      protocol: {
        type: 'graphAPI',
        clientId: '',
        clientSecret: '',
        authority: '',
        email: '',
      },
      emailTemplate: {
        type: 'default',
        renderFormat: `Dear {{SENDER_NAME}},

Thank you for your email. We appreciate you taking the time to reach out to us.

{{AI_REPLY}}

If you have any further questions or need additional assistance, please feel free to contact us.

Best regards,
Support Team
[Organization Name]`,
        footer: 'This response was generated by Bridged AI Assistant',
      },
      replyApprovalConfig: {
        autoApproval: false, // locked by default
        recipients: [],
      },

      // whatsapp KA related
      integrationId: null,
      providerData: {
        type: 'twilio',
        accountSID: '',
        authToken: '',
        phoneNumber: '',
      },
    },
  },
  qualificationAgent: {
    title: '',

    // Where (domain) configuration for qualification agent
    domainConfig: {
      type: 'fullDomain',
      exceptions: [],
      domainId: '',
      paths: [],
      pageMetaDataDomainConfig: {
        fromPublishedDate: '',
        tags: [],
        categories: [],
        authors: [],
        wordsCount: 0,
      },
    },
    // Signal configuration used for building rules and scoring
    signals: [],
    // Stage configuration (score-based or stage-based funnel stages)
    stages: [],
    // Funnel configuration for rule-based stage classification
    funnel: {
      stages: [
        {
          type: 'top',
          condition: {
            type: '',
            operator: '',
            category: '',
            value: 0,
          },
        },
        {
          type: 'middle',
          condition: {
            type: '',
            operator: '',
            category: '',
            value: 0,
          },
        },
        {
          type: 'bottom',
          condition: {
            type: '',
            operator: '',
            category: '',
            value: 0,
          },
        },
      ],
    },
  },
  personalizationAgent: {
    title: '',
    // 'registrant' | 'sponsor' | 'awardsEntrant' — only 'registrant' is selectable for now
    type: '',
    // Design step — single collection (not an array, unlike Rag/KA campaigns), the response
    // engine (same pool as Rag/KA), and the personalization-required fields to generate,
    // gated by the collection's bucket labels.
    collectionId: null,
    collectionTitle: null,
    engineId: null,
    engineTitle: null,
    requiredFields: [],
    // Descriptor of the active/last-started profile import. Status is polled from
    // `getProfileImportStatus`; the profile rows come from `getPersonalizationProfileList`
    // once that import is completed.
    profileImport: {
      source: null, // 'csv' | 'hubspot'
      importId: null,
      mediaId: null,
      fileName: null,
      integrationId: null,
    },
  },
  connectionAgent: {
    title: '',
    // One engine per format: [{ format, pairing, engineId, engineTitle }]. Pairing is only
    // set for one to one ('delegate_sponsor' | 'delegate_delegate').
    formats: [],
    // Both come from the Event Database (D38, D39): the event collection with the programme, which
    // one to many and session recommendations pick from, and the attendee collection with the
    // delegates and sponsors (each row's attendee type says which side they're on).
    sessionsCollectionId: null,
    sessionsCollectionTitle: null,
    attendeeCollectionId: null,
    attendeeCollectionTitle: null,
    rules: {
      initiator: 'delegate',
      pickCap: 8,
      // Accepts per responder; empty is no limit.
      confirmCap: null,
      note: 'optional',
      showScore: true,
      closesAt: null,
      feedback: true,
      showRepNames: false,
      search: false,
      searchCap: 3,
      companies: false,
      exhibitors: false,
      roundtableChoice: false,
      roundtableCap: 2,
    },
    meetings: {
      durationOptions: [15, 20, 30],
      defaultDuration: 20,
      bufferOptions: [5, 10],
      defaultBuffer: 10,
      dayStart: '09:00',
      dayEnd: '17:00',
    },
    // Editing an agent after it's made (`/agents/edit?isConnection=true`): its id and who is in it
    // now. A draft keeps the event it was started in. Both null for a new setup.
    existing: null,
    eventId: null,
  },
});

// Default export for backward compatibility - uses default branding primary color
export const agentState = getAgentState(DEFAULT_BRANDING.primaryColor);
